'use client';

import React, { memo, useMemo } from 'react';

import { Label } from '@repo/types';
import { Badge } from '@repo/ui/components/ui/badge';
import { cn } from '@repo/ui/lib/utils';

interface ArticleCardLabelsProps {
  labels?: Label[];
  className?: string;
}

const PureArticleCardLabels: React.FC<ArticleCardLabelsProps> = ({
  labels,
  className,
}) => {
  const articleLabels = useMemo(
    () => labels?.filter((label, i) => !!label.id && i <= 1) || [],
    [labels],
  );

  return (
    <div
      className={cn(
        'flex items-center gap-1 cred-xl:gap-[5px]',
        (!articleLabels || articleLabels.length === 0) && 'hidden',
        className,
      )}
    >
      {articleLabels &&
        articleLabels.length > 0 &&
        articleLabels.map((label, i) => (
          <Badge
            key={`${label.id}-${i}`}
            className="flex h-fit shrink-0 rounded-[4px] border-none bg-[#E6ECFF] px-1.5 py-0.5 hover:bg-[#E6ECFF] cred-md:px-[7px] cred-md:py-[2.33px] cred-lg:px-[7.6px] cred-lg:py-[2.53px] cred-xl:px-[10px] cred-xl:py-[3.33px]"
          >
            <span className="text-xs font-medium leading-[14px] text-[#1E3A8A] cred-md:text-sm cred-md:leading-4 cred-lg:text-sm cred-lg:leading-4 cred-xl:text-lg cred-xl:leading-[21px]">
              {label.name}
            </span>
          </Badge>
        ))}
    </div>
  );
};
export const ArticleCardLabels = memo(PureArticleCardLabels);
